// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var ReadQuoteError;
(function (ReadQuoteError) {
    ReadQuoteError["UNKNOWN_READ_QUOTE_ERROR"] = "UNKNOWN_READ_QUOTE_ERROR";
    ReadQuoteError["READ_QUOTE_ERROR_EXPIRED"] = "READ_QUOTE_ERROR_EXPIRED";
    ReadQuoteError["READ_QUOTE_ERROR_ALREADY_SIGNED"] = "READ_QUOTE_ERROR_ALREADY_SIGNED";
    ReadQuoteError["READ_QUOTE_ERROR_NOT_FOUND"] = "READ_QUOTE_ERROR_NOT_FOUND";
    ReadQuoteError["READ_QUOTE_ERROR_INTERNAL"] = "READ_QUOTE_ERROR_INTERNAL";
    ReadQuoteError["READ_QUOTE_ERROR_REJECTED"] = "READ_QUOTE_ERROR_REJECTED";
    ReadQuoteError["READ_QUOTE_ERROR_MODIFIED_AFTER_SIGNED"] = "READ_QUOTE_ERROR_MODIFIED_AFTER_SIGNED";
    ReadQuoteError["READ_QUOTE_ERROR_NOT_READABLE"] = "READ_QUOTE_ERROR_NOT_READABLE";
})(ReadQuoteError || (ReadQuoteError = {}));
export var ReadQuoteError_index;
(function (ReadQuoteError_index) {
    ReadQuoteError_index[ReadQuoteError_index["UNKNOWN_READ_QUOTE_ERROR"] = 0] = "UNKNOWN_READ_QUOTE_ERROR";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_EXPIRED"] = 1] = "READ_QUOTE_ERROR_EXPIRED";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_ALREADY_SIGNED"] = 2] = "READ_QUOTE_ERROR_ALREADY_SIGNED";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_NOT_FOUND"] = 3] = "READ_QUOTE_ERROR_NOT_FOUND";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_INTERNAL"] = 4] = "READ_QUOTE_ERROR_INTERNAL";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_REJECTED"] = 5] = "READ_QUOTE_ERROR_REJECTED";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_MODIFIED_AFTER_SIGNED"] = 6] = "READ_QUOTE_ERROR_MODIFIED_AFTER_SIGNED";
    ReadQuoteError_index[ReadQuoteError_index["READ_QUOTE_ERROR_NOT_READABLE"] = 7] = "READ_QUOTE_ERROR_NOT_READABLE";
})(ReadQuoteError_index || (ReadQuoteError_index = {}));
/**
 * Categories of line items in a quote.
 */
export var QuoteLineItemInternalCategory;
(function (QuoteLineItemInternalCategory) {
    QuoteLineItemInternalCategory["UNKNOWN_QUOTE_LINE_ITEM_INTERNAL_CATEGORY"] = "UNKNOWN_QUOTE_LINE_ITEM_INTERNAL_CATEGORY";
    QuoteLineItemInternalCategory["PHONE"] = "PHONE";
    QuoteLineItemInternalCategory["SERVICE"] = "SERVICE";
    QuoteLineItemInternalCategory["DISCOUNT"] = "DISCOUNT";
    QuoteLineItemInternalCategory["HIDDEN"] = "HIDDEN";
})(QuoteLineItemInternalCategory || (QuoteLineItemInternalCategory = {}));
export var QuoteLineItemInternalCategory_index;
(function (QuoteLineItemInternalCategory_index) {
    QuoteLineItemInternalCategory_index[QuoteLineItemInternalCategory_index["UNKNOWN_QUOTE_LINE_ITEM_INTERNAL_CATEGORY"] = 0] = "UNKNOWN_QUOTE_LINE_ITEM_INTERNAL_CATEGORY";
    QuoteLineItemInternalCategory_index[QuoteLineItemInternalCategory_index["PHONE"] = 1] = "PHONE";
    QuoteLineItemInternalCategory_index[QuoteLineItemInternalCategory_index["SERVICE"] = 2] = "SERVICE";
    QuoteLineItemInternalCategory_index[QuoteLineItemInternalCategory_index["DISCOUNT"] = 3] = "DISCOUNT";
    QuoteLineItemInternalCategory_index[QuoteLineItemInternalCategory_index["HIDDEN"] = 4] = "HIDDEN";
})(QuoteLineItemInternalCategory_index || (QuoteLineItemInternalCategory_index = {}));
export var AcceptQuoteError;
(function (AcceptQuoteError) {
    AcceptQuoteError["UNKNOWN_ACCEPT_QUOTE_ERROR"] = "UNKNOWN_ACCEPT_QUOTE_ERROR";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_EXPIRED"] = "ACCEPT_QUOTE_ERROR_EXPIRED";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_ALREADY_SIGNED"] = "ACCEPT_QUOTE_ERROR_ALREADY_SIGNED";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_STALE"] = "ACCEPT_QUOTE_ERROR_STALE";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_NOT_FOUND"] = "ACCEPT_QUOTE_ERROR_NOT_FOUND";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_INTERNAL"] = "ACCEPT_QUOTE_ERROR_INTERNAL";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_REJECTED"] = "ACCEPT_QUOTE_ERROR_REJECTED";
    AcceptQuoteError["ACCEPT_QUOTE_ERROR_NOT_READABLE"] = "ACCEPT_QUOTE_ERROR_NOT_READABLE";
})(AcceptQuoteError || (AcceptQuoteError = {}));
export var AcceptQuoteError_index;
(function (AcceptQuoteError_index) {
    AcceptQuoteError_index[AcceptQuoteError_index["UNKNOWN_ACCEPT_QUOTE_ERROR"] = 0] = "UNKNOWN_ACCEPT_QUOTE_ERROR";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_EXPIRED"] = 1] = "ACCEPT_QUOTE_ERROR_EXPIRED";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_ALREADY_SIGNED"] = 2] = "ACCEPT_QUOTE_ERROR_ALREADY_SIGNED";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_STALE"] = 3] = "ACCEPT_QUOTE_ERROR_STALE";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_NOT_FOUND"] = 4] = "ACCEPT_QUOTE_ERROR_NOT_FOUND";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_INTERNAL"] = 5] = "ACCEPT_QUOTE_ERROR_INTERNAL";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_REJECTED"] = 6] = "ACCEPT_QUOTE_ERROR_REJECTED";
    AcceptQuoteError_index[AcceptQuoteError_index["ACCEPT_QUOTE_ERROR_NOT_READABLE"] = 7] = "ACCEPT_QUOTE_ERROR_NOT_READABLE";
})(AcceptQuoteError_index || (AcceptQuoteError_index = {}));
export var QuoteType;
(function (QuoteType) {
    QuoteType["UNKNOWN_QUOTE_TYPE"] = "UNKNOWN_QUOTE_TYPE";
    QuoteType["QUOTE"] = "QUOTE";
    QuoteType["IT_INSTALLER_ESTIMATE"] = "IT_INSTALLER_ESTIMATE";
    QuoteType["AMENDMENT"] = "AMENDMENT";
    QuoteType["QUOTE_TYPE_LOA"] = "QUOTE_TYPE_LOA";
})(QuoteType || (QuoteType = {}));
export var QuoteType_index;
(function (QuoteType_index) {
    QuoteType_index[QuoteType_index["UNKNOWN_QUOTE_TYPE"] = 0] = "UNKNOWN_QUOTE_TYPE";
    QuoteType_index[QuoteType_index["QUOTE"] = 1] = "QUOTE";
    QuoteType_index[QuoteType_index["IT_INSTALLER_ESTIMATE"] = 2] = "IT_INSTALLER_ESTIMATE";
    QuoteType_index[QuoteType_index["AMENDMENT"] = 3] = "AMENDMENT";
    QuoteType_index[QuoteType_index["QUOTE_TYPE_LOA"] = 4] = "QUOTE_TYPE_LOA";
})(QuoteType_index || (QuoteType_index = {}));
export var TransactionChargeType;
(function (TransactionChargeType) {
    TransactionChargeType["UNKNOWN_TRANSACTION_CHARGE_TYPE"] = "UNKNOWN_TRANSACTION_CHARGE_TYPE";
    TransactionChargeType["STANDARD_TRANSACTION_CHARGE"] = "STANDARD_TRANSACTION_CHARGE";
    TransactionChargeType["NON_STANDARD_TRANSACTION_CHARGE"] = "NON_STANDARD_TRANSACTION_CHARGE";
})(TransactionChargeType || (TransactionChargeType = {}));
export var TransactionChargeType_index;
(function (TransactionChargeType_index) {
    TransactionChargeType_index[TransactionChargeType_index["UNKNOWN_TRANSACTION_CHARGE_TYPE"] = 0] = "UNKNOWN_TRANSACTION_CHARGE_TYPE";
    TransactionChargeType_index[TransactionChargeType_index["STANDARD_TRANSACTION_CHARGE"] = 1] = "STANDARD_TRANSACTION_CHARGE";
    TransactionChargeType_index[TransactionChargeType_index["NON_STANDARD_TRANSACTION_CHARGE"] = 2] = "NON_STANDARD_TRANSACTION_CHARGE";
})(TransactionChargeType_index || (TransactionChargeType_index = {}));
